import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate
} from "pbas-vue-components";
import { translate } from '../trans'
import store from '@/store'

const BeneficiariesStatementsHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.policies",
    type: new InMemoryString("PolicyIdentities[]/Name", {
      getString: item => {
        console.log(item);
        if (!item) return "";
        return item.PolicyIdentities.map(o=>o.Name).join(", ");
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.beneficiaries_statements.declaration_date",
    type: new InMemoryDate("DeclarationDate"),
    sortable: true,
    visible: true,
    searchable: true
  })
];
export default BeneficiariesStatementsHeaders;